/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/movie/shared/desktop/backgroundBlur.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'movie/shared/desktop/backgroundBlur', exports: {} };
const exports = module.exports;



import $ from '@take-2/fd-modules/jQuery';

function onResize() {
    const MAX_BLUR_HEIGHT = 3720;
    const backgroundHeight = $('.js-backgroundBlur').height();
    const isChrome = !!window.chrome;
    // Chrome can handle blurring large images.
    // For other browsers, don't blur if the image is too large as it will cause
    // performance issues with page load and scrolling.
    if (backgroundHeight < MAX_BLUR_HEIGHT || isChrome) {
        $('.js-backgroundBlur-image').attr('filter', 'url(#backgroundBlur)');
    }
}
function init() {
    onResize();
    $(window).on('resize', $.debounce(250, onResize));
}
export default {
    init,
};
